import axios from '../axios'

export default {
    //公司治理
    getCorporateGovernanceList(inOpts) {
        return axios.request({
            cmd:'dynamicApi/companyDynamicList',
            data:inOpts
        })
    }
}